export default __webpack_public_path__ + "static/media/88_desktop.3aa39e07.jpg";